const styles = {
  overlay: {
    height: '100vh',
    width: '100vw',
    backgroundColor: "rgba(255, 255, 255, 0.64)",
    position: 'fixed',
    top: 0,
    zIndex: 100,
    backdropFilter: 'blur(24px)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    overflow: 'hidden',
  },

  container: {
    width: 'auto',
    maxWidth: '532px',
    padding: "32px",
    background: "#FFFFFF",
    borderRadius: "16px",
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    boxShadow: "0px 0px 16px 0px #E5E5E5",
    boxSizing: 'border-box',
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    paddingBottom: '32px',
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.01em",
    color: "#5F5F5F",
  }
} as const

export default styles